import { render, staticRenderFns } from "./NextBackButtons.vue?vue&type=template&id=340362c8&scoped=true&"
import script from "./NextBackButtons.vue?vue&type=script&lang=js&"
export * from "./NextBackButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340362c8",
  null
  
)

export default component.exports